import { useSelector } from "react-redux";

import { ALVYS_SETTINGS_ITEM, API_SETTINGS_ITEM } from "constants/user-settings";
import { IUserSettingItem } from "models/UserSetting";
import { RootState } from "store";
import { useUserFeature } from "./useUserFeature";

export function useIntegrations() {
  const { userDetails } = useSelector((state: RootState) => state.userState);
  const { isAlvysEnabled } = useUserFeature();
  const canManageExternalAPI = Boolean(
    userDetails?.is_admin && userDetails?.tms_external_api_access
  );

  const integrations = [
    isAlvysEnabled && ALVYS_SETTINGS_ITEM,
    canManageExternalAPI && API_SETTINGS_ITEM
  ].filter(Boolean) as IUserSettingItem[];

  return { integrations, canManageExternalAPI };
}
